import { createFileRoute } from '@tanstack/react-router';
import { BrainGraph } from '~/components/brain/BrainGraph';

export const Route = createFileRoute('/_app/brain/map')({
  component: () => <BrainGraph />,
});
